var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./BatchCompletedCoursesModal.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-081f0177\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./BatchCompletedCoursesModal.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/user/BatchCompletedCoursesModal.vue
// module id = 179
// module chunks = 8